/**
 * 產品子類別 - 更新子網頁時使用的狀態
 */
export enum ProductSubItemStatus {
  EMPTY = '',
  /** 新增 */
  ADD = 'add',
  /** 更新 */
  UPDATE = 'update',
  /** 刪除 */
  DELETE = 'delete'
}
